module.exports = __webpack_public_path__ + "static/icon_number01-be7e852914f6f62c5ade3331ff14d466.png";